import React from 'react';
import { ElevateCheckbox } from './ElevateCheckbox';
import { css, cx } from 'linaria';

const textFacetListStyle = css`
  background: #f3f3f3;
`;
export const TextFacet = ({ clickCallback, ...props }) => {
  return (
    <ul className={cx('text-facet-list', textFacetListStyle)}>
      {(props.values || []).map(value => {
        if (!value?.id || value.count === 0) {
          return null;
        }

        return (
          <li key={value.id}>
            <ElevateCheckbox
              label={`${value.label}`}
              count={value.count}
              checked={value.selected}
              onChange={() => clickCallback(value, props)}
            />
          </li>
        );
      })}
    </ul>
  );
};
